enum ButtonType {
  FILL_ICON_TEXT = "fill_icon_text",
  FILL_TEXT = "fill_text",
  FILL_ICON = "fill_icon",
  ICON_TEXT = "icon_text",
  ICON = "icon",
  TEXT = "text",
  LINK = "link",
}

export default ButtonType;
